module.exports = __webpack_public_path__ + "img/03.f46b2781.webp";